export default __webpack_public_path__ + "static/media/Safari.a40e7c8d.svg";